/**
 * Price component
 * 
 * @module price-component
 * @version 1.0.0
 * @extends HTMLElement
 */
 class priceComponent extends HTMLElement {

    /**
     * Product price web component.
     * 
     * @constructor
     */
    constructor() {

        super();

        this.initEvents();
    }

    /**
     * Init events.
     * 
     * @returns {undefined}
     */
    initEvents() {

        // On variant change
        window.addEventListener('variant-change', this.onVariantChange.bind(this));
    }

    /**
     * On variant change.
     * 
     * @param {object} event Event.
     * @returns {undefined}
     */
    onVariantChange(event) {
        
        if(event.detail.product.handle == this.dataset.handle){
            this.update(event.detail.variant);
        }
    }

    /**
     * Update price.
     * 
     * @returns {undefined}
     */
    update(variant) {

        if (variant) {

            this.querySelector('[data-price]').innerHTML = theme.money.format(variant.price);

            let compareAtPrice = this.querySelector('[data-compareatprice]');

            if(compareAtPrice) {

                if (variant.compare_at_price) {

                    compareAtPrice.innerHTML = theme.money.format(variant.compare_at_price);
                
                } else {
    
                    compareAtPrice.innerHTML = '';
                }

                // update sale percentage
                let salePercentage = this.querySelector('[data-salepercentage]');

                if(salePercentage) {
                    let saleDifference = variant.price * 100 / variant.compare_at_price;
                    let salePercentageValue = 100 - saleDifference;

                    if (salePercentageValue > 0) {
                    
                        salePercentage.innerHTML = Math.round(salePercentageValue) + '%';
                    }
                }
            }
        }
    }
}

customElements.define('price-component', priceComponent);
